import React from "react";
import { AppBtn } from "../../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../../ui/modal-full";
import { DeliveryArea, StoreInterface } from "@/assets/interfaces";

interface Props {
  store: StoreInterface;
  show: boolean;
  toggle: (state: boolean) => void;
  formatCurrency: (amount: number) => string;
}

const DeliveryFeesModal: React.FC<Props> = ({ store, show, toggle, formatCurrency }) => {
  return (
    <Modal {...{ show, toggle }} fullOnlyOnMobile title="Delivery Fees" bgClose={false}>
      <ModalBody>
        <div className="flex flex-col items-center gap-2.5">
          {(store?.delivery_areas as DeliveryArea[]).map((i, index) => (
            <div className="flex w-full flex-col bg-grey-fields-100 rounded-10">
              <div className="p-3 md:p-4 border border-grey-border border-opacity-50 rounded-10 bg-white">
                <p className="text-1xs md:text-sm text-black-placeholder">{i?.name}</p>
              </div>
              <div className="rounded-b-xl py-2 px-4 md:py-3 md:px-4">
                <p className="text-1xs md:text-sm font-bold text-black-secondary">{formatCurrency(i.fee)}</p>
              </div>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeliveryFeesModal;
